var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlteration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.582 13.774a3.116 3.116 0 00-2.92 2.043l-2.1-4.2 5.463-10.9a.492.492 0 10-.879-.441l-5.134 10.247L4.878.276a.492.492 0 00-.879.441l5.463 10.9-2.1 4.2a3.114 3.114 0 10-.16 2.51l.009-.012 2.8-5.6 2.8 5.6c0 .006.008.01.011.015a3.113 3.113 0 102.758-4.555zM4.435 19.02a2.131 2.131 0 112.13-2.131 2.134 2.134 0 01-2.13 2.127zm11.147 0a2.131 2.131 0 112.131-2.131 2.133 2.133 0 01-2.131 2.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlteration);
export default __webpack_public_path__ + "static/media/Alteration.752b58e4386aafd89bb4ee3f4ee606e6.svg";
export { ForwardRef as ReactComponent };